import { Box } from "@mui/material";
import Footer from "components/Footer";
import PageDefaultLayout from "components/LayoutContainers/PageDefaultLayout/pageDefaultLayout";
import BreadcrumbHome from "components/Navbars/HomeNavbar/breadcrumbHome";
import NewsList from "components/NewsList/newsList";
import { setAnotherPage } from "context";
import { useMaterialUIController } from "context";
import { useEffect } from "react";

const News = () => {
  const [controller, dispatch] = useMaterialUIController();
  useEffect(() => {
    setAnotherPage(dispatch, true);
  }, []);
  return (
    <PageDefaultLayout>
      <BreadcrumbHome />
      <Box>
        <NewsList />
      </Box>
      <Footer isNotAbsolute={false} />
    </PageDefaultLayout>
  );
};

export default News;
